'use client';

import { useQuery } from '@tanstack/react-query';

import { getMyHandbooks } from '@/lib/api/purchaser/handbooks';
import { useAuth } from '@/lib/auth/AuthProvider';
import { queryKeys } from '@/lib/query';

import { useBreedHandbooksEnabled } from './useBreedHandbooksEnabled';

export function useOwnsHandbook(breedSlug: string): boolean {
  const { isEnabled } = useBreedHandbooksEnabled();
  const { status } = useAuth();
  const { data } = useQuery({
    queryKey: queryKeys.purchaser.handbooks.list(),
    queryFn: getMyHandbooks,
    enabled: isEnabled && status === 'authenticated',
    retry: false
  });
  return Boolean(data?.owned.some((item) => item.breedSlug === breedSlug));
}
